var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0206 10.0782L13.8759 12.9328L12.9326 13.8762L10.0779 11.0208C9.01574 11.8723 7.69459 12.3354 6.33325 12.3335C3.02125 12.3335 0.333252 9.6455 0.333252 6.3335C0.333252 3.0215 3.02125 0.333496 6.33325 0.333496C9.64525 0.333496 12.3333 3.0215 12.3333 6.3335C12.3352 7.69483 11.8721 9.01599 11.0206 10.0782ZM9.68325 9.5835C10.5293 8.71342 11.0018 7.54712 10.9999 6.3335C10.9999 3.75483 8.91125 1.66683 6.33325 1.66683C3.75459 1.66683 1.66659 3.75483 1.66659 6.3335C1.66659 8.9115 3.75459 11.0002 6.33325 11.0002C7.54687 11.0021 8.71318 10.5296 9.58325 9.6835L9.68325 9.5835V9.5835Z",
    fill: "#7E7E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.c8e61400da13203d503747b5383b6bb8.svg";
export { ForwardRef as ReactComponent };